import type { Etat } from '../partage/api/types';
import { etatSuivant, MOTS_ETAT, ROND_COCHE, ROND_DECOCHE, rondQuiTourne } from '../partage/vocabulaire';

/**
 * Ce que fait le rond d'une bulle de la Liste quand on le touche (ticket 05 du chantier
 * telephone).
 *
 * **Au téléphone, le rond coche** : un toucher, et la bulle est faite, par le même « C'est
 * fait » que la fiche (l'inventaire de ce qui restait dedans) ; un second toucher
 * la défait, par le même « Annuler » (elle retrouve l'état d'avant la coche). « J'attends un
 * retour » reste dans la fiche : un rond qui passe par trois états, au pouce et debout, se
 * trompe une fois sur deux.
 *
 * **Sur ordinateur, rien ne change** : la pastille fait tourner ses états (`etatSuivant`).
 *
 * Une bulle qui attend le monde ou gardée comme idée se coche aussi : le rond dit « c'est
 * fait », quel que soit le chemin par lequel on y arrive.
 */
export type GesteDuRond =
  | { sorte: 'cocher' }
  | { sorte: 'decocher' }
  | { sorte: 'etat'; etat: Etat };

export function gesteDuRond(etat: Etat, auPouce: boolean): GesteDuRond {
  if (!auPouce) return { sorte: 'etat', etat: etatSuivant(etat) };
  return etat === 'fait' ? { sorte: 'decocher' } : { sorte: 'cocher' };
}

/**
 * Le titre du rond (au survol) : ce que fera le toucher. Sur ordinateur, l'état d'où l'on part
 * et celui où l'on arrive ; au téléphone, « c'est fait », ou « annuler » sur une bulle faite.
 */
export function titreDuRond(etat: Etat, auPouce: boolean): string {
  const geste = gesteDuRond(etat, auPouce);
  if (geste.sorte === 'etat') return rondQuiTourne(MOTS_ETAT[etat], MOTS_ETAT[geste.etat]);
  return geste.sorte === 'cocher' ? ROND_COCHE : ROND_DECOCHE;
}
